// Libraries
import React from 'react';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';
import {css} from 'aphrodite/no-important';
import $ from 'jquery';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';

export default class Glyph extends React.Component {
    static Size = {
        XXSmall: "xx-small",
        XSmall: "x-small",
        Small: "small",
        Medium: "medium", // Default
        Large: "large",
        XLarge: "x-large",
        XXLarge: "xx-large",
    };
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            svg: {
                width: "100%",
                height: "100%",
            },
        });
        const asset = this.props.asset;
        return (
            <ReactSVG ref="wrapper" className={css(styles.svg)} path={asset} callback={svg => this.updateStyling(svg)} />
        );
    }
    componentDidMount() {
        this.updateCSSClasses();
    }
    componentDidUpdate() {
        this.updateCSSClasses();
    }
    updateCSSClasses() {
        const sizeMetrics = {
            [Glyph.Size.XXSmall]: CoreMetrics.IconSize.XXSmall(),
            [Glyph.Size.XSmall]: CoreMetrics.IconSize.XSmall(),
            [Glyph.Size.Small]: CoreMetrics.IconSize.Small(),
            [Glyph.Size.Medium]: CoreMetrics.IconSize.Medium(),
            [Glyph.Size.Large]: CoreMetrics.IconSize.Large(),
            [Glyph.Size.XLarge]: CoreMetrics.IconSize.XLarge(),
            [Glyph.Size.XXLarge]: CoreMetrics.IconSize.XXLarge(),
        };

        const {size, asset} = this.props;
        const sizeMetric = sizeMetrics[size];
        const styles = createExpandableMediaQueryStylesheet({
            wrapper: {
                width: sizeMetric,
                height: sizeMetric,
            },
            placeholder: {
                backgroundColor: CoreMetrics.Color.Debug,
            },
        });
        let combinedStyles = [styles.wrapper].concat(this.props.styles);
        if (asset === "") {
            combinedStyles.push(styles.placeholder);
        }

        // Update the CSS classes
        const realWrapper = this.refs.wrapper.container;
        realWrapper.className = css(combinedStyles);
    }
    updateStyling(svg) {
        // Update the fill color
        const fillColor = this.props.fillColor;
        if (fillColor != null) {
            $(svg).find("path").css({
                fill: fillColor,
            });
            $(svg).find("circle").css({
                fill: fillColor,
            });
        }
    }
}
Glyph.defaultProps = {
    styles: [],
    asset: "",
    size: Glyph.Size.Medium,
    fillColor: null,
};
Glyph.propTypes = {
    styles: PropTypes.array,
    asset: PropTypes.string,
    size: PropTypes.string,
    fillColor: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/core/Glyph.jsx